module.exports = __webpack_public_path__ + "img/edit_pencil.b4427d92.svg";